import React from "react"
export function Meals(props) {
  return (
    <svg viewBox="0 0 24 24" {...props}>
      <g
        id="prefix__Artboard-Copy-20"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <path
          d="M20.012 0v24h-2.998v-6.998h-1.489c-.022 0-.044 0-.066-.002-.853-.037-1.483-.584-1.446-1.447C14.453 5.181 15.853 0 18.469 0h1.543zm-15.2 0v5.469c0 .431.345.781.772.781.427 0 .774-.35.774-.781V0h2.317v5.469c0 .431.346.781.773.781.427 0 .773-.35.773-.781V0h1.785v7.813c0 1.725-1.291 3.187-3 3.187v13H6.01V11C4.3 11 3.012 9.538 3.012 7.812V0h1.8z"
          id="prefix__Cutlery"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}
